import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'
import { Mixpanel } from '@/analytics/mixpanel'
import { applyNavbarButtons } from '@/pages-site-v2/helpers/navbar'

import { initializeBestBooksCarousels } from './carousel'
import { initializeBestBooksCoverFallbacks } from './coverFallbacks'
import { initializeBestBooksCtaTracking } from './ctaTracking'
import { initializeBestBooksFixedBanner } from './fixedBanner'

const { header: initializePublicNavbar } = require('@/assets.v2/js/header.js')
const initializedHtmlTextToggles = new WeakSet<HTMLButtonElement>()

/**
 * Enable the accessible Read More controls emitted in prerendered book blurbs.
 *
 * Each control is initialized once. Expanding reveals every remainder node and
 * removes the collapsed ellipsis; collapsing restores the initial 400-character
 * view without duplicating or replacing the description markup.
 */
export function initializeBestBooksHtmlText(root: ParentNode = document): void {
  const toggles = root.querySelectorAll<HTMLButtonElement>(
    '[data-best-books-html-text-toggle]',
  )
  for (const toggle of toggles) {
    if (initializedHtmlTextToggles.has(toggle)) {
      continue
    }

    const textComponent = toggle.closest('.sf-html-text')
    if (!textComponent) {
      continue
    }
    initializedHtmlTextToggles.add(toggle)
    const remainderNodes = textComponent.querySelectorAll<HTMLElement>(
      '[data-best-books-html-text-remainder]',
    )
    const ellipsis = textComponent.querySelector<HTMLElement>(
      '.sf-html-text__ellipsis',
    )

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') !== 'true'
      for (const remainderNode of remainderNodes) {
        remainderNode.hidden = !expanded
      }
      if (ellipsis) {
        ellipsis.hidden = expanded
      }
      toggle.setAttribute('aria-expanded', String(expanded))
      toggle.textContent = expanded ? 'Show less' : 'Read More'
    })
  }
}

export function initPageBestBooks(): void {
  initMixpanel()
  sentryInit()

  document.addEventListener('DOMContentLoaded', function () {
    if (
      document.querySelector(
        '.best-books-list-page > .header-wrapper .hamburger',
      )
    ) {
      initializePublicNavbar()
      applyNavbarButtons()
    }

    initializeBestBooksCoverFallbacks()
    initializeBestBooksFixedBanner()
    initializeBestBooksHtmlText()
    initializeBestBooksCarousels()
    initializeBestBooksCtaTracking()

    setTimeout(() => {
      Mixpanel.pageView()
    }, 1500)
  })
}
